import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Check if Supabase is configured
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);

// Create a mock auth object for when Supabase is not configured
const mockAuth = {
  onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
  getSession: () => Promise.resolve({ data: { session: null }, error: null }),
  getUser: () => Promise.resolve({ data: { user: null }, error: null }),
  signInWithPassword: () => Promise.resolve({ data: null, error: new Error('Supabase not configured') }),
  signUp: () => Promise.resolve({ data: null, error: new Error('Supabase not configured') }),
  signOut: () => Promise.resolve({ error: null }),
  resend: () => Promise.resolve({ error: new Error('Supabase not configured') }),
};

// Create a mock functions object
const mockFunctions = {
  invoke: () => Promise.resolve({ data: null, error: new Error('Supabase not configured') }),
};

// Create client only if configured, otherwise create a mock object
export const supabase: SupabaseClient<Database> = isSupabaseConfigured
  ? createClient<Database>(supabaseUrl, supabaseKey, {
      auth: {
        storage: localStorage,
        persistSession: true,
        autoRefreshToken: true,
      }
    })
  : {
      auth: mockAuth,
      functions: mockFunctions,
      from: () => ({
        select: () => Promise.resolve({ data: null, error: new Error('Supabase not configured') }),
        insert: () => Promise.resolve({ data: null, error: new Error('Supabase not configured') }),
        update: () => Promise.resolve({ data: null, error: new Error('Supabase not configured') }),
        delete: () => Promise.resolve({ data: null, error: new Error('Supabase not configured') }),
        upsert: () => Promise.resolve({ data: null, error: new Error('Supabase not configured') }),
      }),
    } as unknown as SupabaseClient<Database>;
